export const getFormatDateRangeValues = (dateRange, format) => {
  if (Array.isArray(dateRange)) {
    return dateRange.map((date) => date.format(format));
  }
  return [undefined, undefined];
};
